<script lang="ts">
  import Caret from "~icons/ph/caret-down";

  let { gross }: { gross: number } = $props();

  function isInRange(amount: number, [min, max = Infinity]: [number, number?]) {
    return min <= amount && amount <= max;
  }
</script>

<details>
  <summary>Why are fees and deductions coming out?<Caret /></summary>
  <p>
    The JLG fee covers legal costs, administrative expenses, and labor involved in working on your case.
  </p>
  <p>
    VAT (Value Added Tax) covers taxes we’re required to pay to the government, since our legal services are taxable.
  </p>
  <p>
    Your fees are protected by the SRA fee cap, and the JLG fee is capped based on offer amount:
  </p>
  <div class="rounded-lg overflow-clip border">
    <table class="fee-cap-table">
      <thead>
        <tr>
          <th>Offer amount</th>
          <th>Max % rate of charge</th>
          <th>Max total charge</th>
        </tr>
      </thead>
      <tbody>
        <tr class:highlight={isInRange(gross, [1, 1_499])}>
          <td>£1–1,499</td>
          <td>30%</td>
          <td>£420</td>
        </tr>
        <tr class:highlight={isInRange(gross, [1_500, 9_999])}>
          <td>£1,500–9,999</td>
          <td>28%</td>
          <td>£2,500</td>
        </tr>
        <tr class:highlight={isInRange(gross, [10_000, 24_999])}>
          <td>£10,000–24,999</td>
          <td>25%</td>
          <td>£5,000</td>
        </tr>
        <tr class:highlight={isInRange(gross, [25_000, 49_999])}>
          <td>£25,000–49,999</td>
          <td>20%</td>
          <td>£7,500</td>
        </tr>
        <tr class:highlight={isInRange(gross, [50_000])}>
          <td>£50,000 or above</td>
          <td>15%</td>
          <td>£10,000</td>
        </tr>
      </tbody>
    </table>
  </div>
</details>

<style lang="postcss">
  .fee-cap-table {
    @apply w-full text-sm text-left;

    th,
    td {
      @apply font-medium p-2;
      &:first-child {
        @apply whitespace-nowrap;
      }
    }

    th {
      @apply text-gray-600 bg-gray-100 align-top;
    }

    tbody {
      @apply divide-y border-t;
    }

    tr {
      @apply divide-x;
    }

    .highlight > td {
      @apply text-sky-700 bg-sky-100 font-bold;
    }
  }
</style>
